import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["question", "checkbox", "waiverPolicy"]
  static values = { waiverExplicit: Boolean }

  connect() {
    this.update()
  }

  update(event) {
    if (this.hasWaiverPolicyTarget && event?.target === this.waiverPolicyTarget) this.waiverExplicitValue = true
    const country = this.element.querySelector('[name="address[country]"]')
    const australian = country?.value === "AU"
    this.questionTarget.hidden = !australian
    if (!australian) this.checkboxTarget.checked = false
    if (this.hasWaiverPolicyTarget && !this.waiverExplicitValue) {
      this.waiverPolicyTarget.value = this.checkboxTarget.checked ? "non_members" : "no"
    }
  }
}
